import { render, staticRenderFns } from "./OrgUser.vue?vue&type=template&id=31dcaa48&scoped=true&"
import script from "./OrgUser.vue?vue&type=script&lang=js&"
export * from "./OrgUser.vue?vue&type=script&lang=js&"
import style0 from "./OrgUser.vue?vue&type=style&index=0&id=31dcaa48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31dcaa48",
  null
  
)

export default component.exports